import { useCallback, useSyncExternalStore } from 'react';
import { isGuarded, subscribeGuards } from './taskCloseGuard';

/**
 * Reactive read of `isGuarded`: true while the view's customer-mfe reports a
 * booking in progress. Always false without a view key, and for legacy views,
 * which never register.
 */
export default function useIsBookingGuarded(viewKey?: string): boolean {
  const getSnapshot = useCallback(
    () => (viewKey ? isGuarded(viewKey) : false),
    [viewKey],
  );
  return useSyncExternalStore(subscribeGuards, getSnapshot);
}
